import classNames from '@utils/classnames';
import React from 'react';
import { NavLink } from 'react-router-dom';

import { Avatar } from '../avatar/Avatar';

export interface ISidebarNavItemProps {
  to: string;
  label: string;
  icon: React.ElementType<{ className?: string; 'aria-hidden'?: boolean }>;
  /** Grey counter pill at the end of the row (e.g. incoming documents). */
  count?: number;
  /** Small brand dot at the end of the row (e.g. unread notifications). */
  hasIndicator?: boolean;
  /** Match the route exactly instead of by prefix. */
  end?: boolean;
}

/**
 * One row in the sidebar navigation. The current route is the only coloured
 * item in the whole navigation.
 */
export const SidebarNavItem: React.FC<ISidebarNavItemProps> = (props) => {
  const { to, label, icon: Icon, count, hasIndicator, end } = props;

  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) => classNames('sidebar-item', { 'sidebar-item-active': isActive })}
    >
      <Icon className="sidebar-item-icon" aria-hidden />
      <span className="sidebar-item-label">{label}</span>
      {count != null && <span className="sidebar-item-count">{count}</span>}
      {hasIndicator && <span className="h-2 w-2 shrink-0 rounded-full bg-brand" aria-label="Ongelezen" />}
    </NavLink>
  );
};

export interface ISidebarUserItemProps {
  to: string;
  name: string;
  imageUrl?: string | null;
  /** Secondary line under the name (organisation, role). */
  meta?: string;
}

/** The signed-in user, pinned to the bottom of the sidebar. */
export const SidebarUserItem: React.FC<ISidebarUserItemProps> = (props) => {
  const { to, name, imageUrl, meta } = props;

  return (
    <NavLink
      to={to}
      className={({ isActive }) => classNames('sidebar-item h-auto py-1.5', { 'sidebar-item-active': isActive })}
    >
      <Avatar name={name} url={imageUrl} size="sm" />
      <span className="flex min-w-0 flex-col leading-tight">
        <span className="truncate text-sm font-medium text-fg">{name}</span>
        {meta && <span className="truncate text-2xs font-regular text-fg-muted">{meta}</span>}
      </span>
    </NavLink>
  );
};
